module.exports = __webpack_public_path__ + "static/6-b3c9ea31b54d6c2c98fcf7bdbd2021ee.png";